import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getMenuEntryKey } from '#pplx/frontend/composer-sdk/internal/typeahead/typeaheadMenuData.js';
import { toTypeaheadMenuEntries } from '#pplx/frontend/composer-sdk/internal/typeahead/typeaheadMenuData.js';
import { TypeaheadMenuEntry } from '#pplx/frontend/composer-sdk/internal/typeahead/TypeaheadMenuEntry.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
export function TypeaheadMenuSection({ section, isFirst, idBase, selectedIndex, rowSize, highlightStyle, separateSectionHeaders, groupTitleVariant, onHighlight, onSelect, listboxRef, }) {
    const entries = useMemo(() => toTypeaheadMenuEntries(section.rows), [section.rows]);
    const itemProps = {
        idBase,
        selectedIndex,
        rowSize,
        highlightStyle,
        groupTitleVariant,
        onHighlight,
        onSelect,
        listboxRef,
    };
    return (_jsxs(_Fragment, { children: [section.sectionTitle !== null && section.sectionTitle !== undefined && (_jsx("div", { className: classNames('text-tertiary text-xs', isFirst || !separateSectionHeaders ? 'py-1' : 'pb-1 pt-3', rowSize === 'comfortable' ? 'px-3' : 'px-2'), children: section.sectionTitle })), entries.map((entry) => (_jsx(TypeaheadMenuEntry, { entry: entry, ...itemProps }, getMenuEntryKey(entry, idBase))))] }));
}
//# sourceMappingURL=TypeaheadMenuSection.js.map